import React, { type FunctionComponent, Fragment } from 'react'
import FilterBar from 'legacy/components/FilterBar'
import AppFrame from 'legacy/components/AppFrame/AppFrame'
import { type UseListReportRequestsPayload } from 'legacy/sections/generated-reports/graphql/list.hooks'
import { GeneratedReportsListEmptyView } from 'legacy/sections/generated-reports/components/list/components/GeneratedReportsListEmptyView'
import { GeneratedReportsListRouteToNew } from 'legacy/sections/generated-reports/components/list/components/GeneratedReportsListRouteToNew'
import { GeneratedReportsListTable } from 'legacy/sections/generated-reports/components/list/components/GeneratedReportsListTable'
import { type UseReportViewDownloadBehaviour } from 'legacy/sections/generated-reports/graphql/reportViewDownloadUrl.hooks'

export interface GeneratedReportsListBodyProps
  extends UseListReportRequestsPayload,
    UseReportViewDownloadBehaviour {}

export const GeneratedReportsListBody: FunctionComponent<GeneratedReportsListBodyProps> = ({
  loading,
  called,
  totalCount,
  ...rest
}) => {
  const shouldShowEmptyView = called && !loading && totalCount === 0

  if (shouldShowEmptyView) {
    return <GeneratedReportsListEmptyView />
  }

  return (
    <Fragment>
      <AppFrame.ContentBar>
        <FilterBar justifyContent="flex-end">
          <FilterBar.Item>
            <GeneratedReportsListRouteToNew labelId="generatedReports.newReport.title" />
          </FilterBar.Item>
        </FilterBar>
      </AppFrame.ContentBar>
      <GeneratedReportsListTable loading={loading} totalCount={totalCount} {...rest} />
    </Fragment>
  )
}
